const Utils = (() => {


    const debounce = (func, delay) => {
        let timeoutId
        return function (...args) {
            clearTimeout(timeoutId)
            timeoutId = setTimeout(() => func.apply(this, args), delay)
        }
    };

    const capitalize = (str) => {
        const firstLetter = str.charAt(0)
        const firstLetterCap = firstLetter.toUpperCase()
        const remainingLetters = str.slice(1)
        return firstLetterCap + remainingLetters
    };

    

    return {
        debounce,
        capitalize
    };

})();

export default Utils;